import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import NotFoundPage from '~/pages/NotFoundPage';
import { LoginPageProps } from '~/pages/LoginPage/LoginPage';
import { ChangePasswordPageProps } from '~/pages/ChangePasswordPage/ChangePasswordPage';
import { ChangePasswordConfirmPageProps } from '~/pages/ChangePasswordConfirmPage/ChangePasswordConfirmPage';
import { AuthorizePageProps } from '~/pages/AuthorizePage/AuthorizePage';
import { CallbackPageProps } from '~/pages/CallbackPage/CallbackPage';
import CustomPageLoader from '../components/CustomPageLoader';
import FormLayout from '../layouts/FormLayout/FormLayout';
import MobileLayout from '../layouts/MobileLayout/MobileLayout';
import Constants from './Constants';

const LoginPage = (props: LoginPageProps) => <CustomPageLoader loader={() => import('../pages/LoginPage')} {...props} />;
const AuthorizePage = (props: AuthorizePageProps) => <CustomPageLoader loader={() => import('../pages/AuthorizePage')} {...props} />;
const CallbackPage = (props: CallbackPageProps) => <CustomPageLoader loader={() => import('../pages/CallbackPage')} {...props} />;
const ChangePasswordPage = (props: ChangePasswordPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordPage')} {...props} />;
const ChangePasswordConfirmPage = (props: ChangePasswordConfirmPageProps) => <CustomPageLoader loader={() => import('../pages/ChangePasswordConfirmPage')} {...props} />;
const LogoffPage = () => <CustomPageLoader loader={() => import('../pages/LogoffPage')} />;
const LoggingTestPage = () => <CustomPageLoader loader={() => import('../pages/LoggingTestPage')} />;
const AccessErrorPage = () => <CustomPageLoader loader={() => import('~/pages/AccessErrorPage')} />;
const TimeoutErrorPage = () => <CustomPageLoader loader={() => import('~/pages/TimeoutErrorPage')} />;
const AfterCentralizationPage = () => <CustomPageLoader loader={() => import('~/pages/AfterCentralizationPage')} />;

const GetInternalRoute = (route: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  const fromURI = queryParams.get('fromURI');
  const isMobileIndicatorStored = (sessionStorage.getItem('mobileDeviceMode') === 'true');
  switch (route) {
    case Constants.Pages.mobile:
      return (
        <Route
          path={Constants.Pages.mobile}
          element={
            <MobileLayout>
              {fromURI === null ? <LogoffPage /> : <LoginPage mobileDeviceMode />}
            </MobileLayout>
          }
        />
      );
    case Constants.Pages.home:
      return (
        <Route
          path={Constants.Pages.home}
          element={
            <FormLayout>
              {/* eslint-disable-next-line no-nested-ternary */}
              {fromURI === null ? <LogoffPage /> :
                isMobileIndicatorStored ? <Navigate to={{ pathname: Constants.Pages.mobile, search: `?fromURI=${fromURI}` }} /> : <LoginPage mobileDeviceMode={false} />}
            </FormLayout>
          }
        />
      );
    case Constants.Pages.authorize:
      return (
        <Route
          path={Constants.Pages.authorize}
          element={
            <FormLayout>
              <AuthorizePage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.mobileChangePassword:
      return (
        <Route
          path={Constants.Pages.mobileChangePassword}
          element={
            <MobileLayout>
              <ChangePasswordPage mobileDeviceMode />
            </MobileLayout>
          }
        />
      );
    case Constants.Pages.changePassword:
      return (
        <Route
          path={Constants.Pages.changePassword}
          element={
            <FormLayout>
              {isMobileIndicatorStored ?
                <Navigate to={{ pathname: Constants.Pages.mobileChangePassword }} /> :
                <ChangePasswordPage mobileDeviceMode={false} />}
            </FormLayout>
          }
        />
      );
    case Constants.Pages.mobileChangePasswordConfirm:
      return (
        <Route
          path={Constants.Pages.mobileChangePasswordConfirm}
          element={
            <MobileLayout>
              <ChangePasswordConfirmPage mobileDeviceMode />
            </MobileLayout>
          }
        />
      );
    case Constants.Pages.changePasswordConfirm:
      return (
        <Route
          path={Constants.Pages.changePasswordConfirm}
          element={
            <FormLayout>
              {isMobileIndicatorStored ?
                <Navigate to={{ pathname: Constants.Pages.mobileChangePasswordConfirm }} /> :
                <ChangePasswordConfirmPage mobileDeviceMode={false} />}
            </FormLayout>
          }
        />
      );
    case Constants.Pages.logOff:
      return (
        <Route
          path={Constants.Pages.logOff}
          element={
            <LogoffPage />
          }
        />
      );
    case Constants.Pages.loggingTest:
      return (
        <Route
          path={Constants.Pages.loggingTest}
          element={
            <FormLayout>
              <LoggingTestPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.accessError:
      return (
        <Route
          path={Constants.Pages.accessError}
          element={
            <FormLayout>
              <AccessErrorPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.mobileTimeoutError:
      return (
        <Route
          path={Constants.Pages.mobileTimeoutError}
          element={
            <MobileLayout>
              <TimeoutErrorPage />
            </MobileLayout>
          }
        />
      );
    case Constants.Pages.afterCentralization:
      return (
        <Route
          path={Constants.Pages.afterCentralization}
          element={
            <FormLayout>
              <AfterCentralizationPage />
            </FormLayout>
          }
        />
      );
    case Constants.Pages.authorizeCallback:
      return (
        <Route
          path={Constants.Pages.authorizeCallback}
          element={
            <FormLayout>
              <CallbackPage />
            </FormLayout>
          }
        />
      );
    default:
      return (
        <Route
          path={Constants.Pages.catchAll}
          element={
            <FormLayout>
              <NotFoundPage />
            </FormLayout>
          }
        />
      );
  }
};

export default GetInternalRoute;
